import { ApiRef, createApiRef } from '@backstage/core-plugin-api';
import { TemplateData } from './templatesandaddons.objects';

export const templateApiRef: ApiRef<TemplateApi> = createApiRef<TemplateApi>({
  /**
   * API for managing AI templates within the ecosystem.
   * Provides methods to retrieve and interact with template data.
   */
  id: 'plugin.aiecosystem-template.api',
});

export interface TemplateApi {
  /**
   * Get all templates available in the system
   * @returns An array of all templates
   */
  getAllTemplates(): Promise<TemplateData[]>;

  /**
   * Get a template by its ID
   * @param id - The ID of the template to retrieve
   * @returns The template with the given ID, or undefined if not found
   * @throws Error if the template cannot be found or another error occurs
   */
  getTemplateById(id: string): Promise<TemplateData | undefined>;
}
